export default "__VITE_ASSET__DWgQ$4cR__"